import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { BugtrackerSupportFormInterface } from '@zaoblako/shared/modules/bugtracker/dtos/bugtracker-support.form.dto';
import { BugtrackerErrorEntryFindManyInterface } from '@zaoblako/shared/modules/bugtracker/dtos/bugtracker-error-entry-find-many.dto';
import { BugtrackerErrorEntryPageInterface } from '@zaoblako/shared/modules/bugtracker/dtos/bugtracker-error-entry-page.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisSystemBugtrackerService extends BaseService {
  protected baseUrl = '/basis/system/bugtracker';

  public support(body: BugtrackerSupportFormInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/support`, body);
  }

  public getHistory(query?: BugtrackerErrorEntryFindManyInterface): Observable<BugtrackerErrorEntryPageInterface> {
    return this.http.get<BugtrackerErrorEntryPageInterface>(`${this.baseUrl}/history`, {
      params: query
        ? this.objectToHttpParams(query)
        : {}
    });
  }
}
